import { Button } from "primereact/button";
import { Message } from "primereact/message";

import { Dialog, DialogHeader, Icon } from "@/ds";
import { RoleSummary } from "../role-summary";
import {
  LINKED_USERS_ACTION,
  LINKED_USERS_TITLE,
  ROLE_IN_USE_DESCRIPTION,
  ROLE_IN_USE_GUIDANCE,
  ROLE_IN_USE_TITLE,
} from "./role-in-use-dialog.constants";
import styles from "./role-in-use-dialog.module.scss";
import type { RoleInUseDialogViewModel } from "./types-role-in-use-dialog";

/** Pop-up de bloqueio (Figma 4656:290318): resumo, quantidade de usuários vinculados e o atalho para a aba Usuários. */
export function RoleInUseDialogView({
  role,
  count,
  countLabel,
  onClose,
  onGoToUsers,
}: RoleInUseDialogViewModel) {
  return (
    <Dialog
      visible
      className={styles.dialog}
      header={
        <DialogHeader
          icon="exclamation-triangle"
          tone="warn"
          title={ROLE_IN_USE_TITLE}
          subtitle={ROLE_IN_USE_DESCRIPTION}
        />
      }
      onHide={onClose}
      footer={
        <div className={styles.footer}>
          <Button
            type="button"
            label="Fechar"
            severity="secondary"
            outlined
            onClick={onClose}
            data-testid="role-in-use-close"
          />
        </div>
      }
      data-testid="role-in-use-dialog"
    >
      <div className={styles.body}>
        <RoleSummary role={role} testId="role-in-use-summary" />

        <section
          className={styles.users}
          aria-labelledby="linked-users-title"
          data-testid="role-in-use-users"
        >
          <h3 id="linked-users-title" className={styles.usersTitle}>
            {LINKED_USERS_TITLE}
          </h3>

          <div className={styles.usersCard}>
            <p className={styles.count}>
              <strong>{count}</strong>
              <span>{countLabel}</span>
            </p>

            <Button
              type="button"
              className={styles.usersAction}
              label={LINKED_USERS_ACTION}
              icon={<Icon name="arrow-right" size={14} />}
              iconPos="right"
              severity="secondary"
              text
              onClick={onGoToUsers}
              data-testid="role-in-use-go-to-users"
            />
          </div>
        </section>

        <Message
          severity="info"
          icon={<Icon name="info-circle" size={14} />}
          text={ROLE_IN_USE_GUIDANCE}
          role="note"
          className="p-message-block p-message-sm"
          data-testid="role-in-use-guidance"
        />
      </div>
    </Dialog>
  );
}
